import { render } from "./MonTargetInfoSection.vue?vue&type=template&id=4aaa7711&scoped=true"
import script from "./MonTargetInfoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MonTargetInfoSection.vue?vue&type=script&setup=true&lang=js"

import "./MonTargetInfoSection.vue?vue&type=style&index=0&id=4aaa7711&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaa7711"],['__file',"src/containers/popup/MonTargetInfoSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aaa7711"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aaa7711', __exports__)) {
    api.reload('4aaa7711', __exports__)
  }
  
  module.hot.accept("./MonTargetInfoSection.vue?vue&type=template&id=4aaa7711&scoped=true", () => {
    api.rerender('4aaa7711', render)
  })

}


export default __exports__